import { CreateProvisionWasm } from "@pdfking/wasm-core"
import { CreateFunctions } from "../generated/Encoders"
import wasm32 from "../libs/binary32.wasm"
import wasm64 from "../libs/binary64.wasm"

export const Provision = CreateProvisionWasm({ wasm32, wasm64 }, CreateFunctions)
